import React from 'react';
import { ReturnDisputeRow } from '../callCenterReturnsDisputesTypes';
import { PriorityBadge, StatusBadge, ViewButton, IssueCard } from '../../shared';
import sharedStyles from '../../shared/IssueTable.module.css';
import styles from './ReturnsDisputesTable.module.css';

interface ReturnsDisputesTableProps {
  rows: ReturnDisputeRow[];
  onView?: (id: string) => void;
}

export const ReturnsDisputesTable: React.FC<ReturnsDisputesTableProps> = ({ rows, onView }) => {
  return (
    <IssueCard title="Returns & Disputes">
      <div className={sharedStyles.tableWrap}>
        <table className={sharedStyles.table}>
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>ORDER #</th>
              <th>CUSTOMER</th>
              <th>RETURN REASON</th>
              <th>PRIORITY</th>
              <th>APPROVAL STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={sharedStyles.ticketId}>{row.ticketId}</td>
                <td>{row.orderId}</td>
                <td className={sharedStyles.bold}>{row.customer}</td>
                <td className={styles.reason}>{row.returnReason}</td>
                <td>
                  <PriorityBadge priority={row.priority} />
                </td>
                <td>
                  <StatusBadge status={row.approvalStatus} />
                </td>
                <td>
                  {row.approvalStatus === 'Pending Review' ? (
                    <ViewButton variant="process" label="Process" onClick={() => onView?.(row.id)} />
                  ) : (
                    <ViewButton onClick={() => onView?.(row.id)} />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </IssueCard>
  );
};
